import { css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';

/**
 * Mobile button atom. Used in mobile navigation.
 * Background color alternates between connected and not connected mode.
 *
 * href - The mobile button href.
 * text - The mobile button text.
 * id - The mobile button id, must be unique.
 * icon - The mobile button image or content.
 */
@customElement('nn-mobile-button')
export class MobileButton extends LitElement {
  static styles = css`
    .anchor {
      display: inline-block;
      width: 100%;
    }
    @media (max-width: 767px) {
      .navbar-mobile-header--img {
        align-items: center;
        background-color: var(
          --nn-mobile-button_navbar-mobile-header--img_background,
          #edf0f5
        );
        border-radius: var(
          --nn-mobile-button_navbar-mobile-header--img_border-radius,
          10px
        );
        border: 1px solid
          var(
            --nn-mobile-button_navbar-mobile-header--img_border-color,
            transparent
          );
        display: flex;
        height: var(--nn-mobile-button_navbar-mobile-header--img_height, 46px);
        justify-content: center;
        padding: var(--nn-mobile-button_navbar-mobile-header--img_padding, 0);
        width: var(--nn-mobile-button_navbar-mobile-header--img_width, 100%);
      }
      svg {
        height: var(--nn-mobile-button_svg_height, 24px);
        width: var(--nn-mobile-button_svg_width, auto);
      }
    }
  `;

  @property({ type: String }) href = '#';

  @property({ type: String }) text = 'Mobile button';

  @property({ type: String }) id = 'mobile-header-menu-link';

  render() {
    return html`
      <a
        id="${this.id}"
        class="anchor"
        href="${this.href}"
        rel="nofollow"
        title="${this.text}"
      >
        <div class="navbar-mobile-header--img">
          <slot name="icon"></slot>
        </div>
      </a>
    `;
  }
}
